<template>
  <div :class="[{ 'nav-open': $sidebar.showSidebar }]" class="wrapper">
    <notifications />

    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <!-- <user-menu /> -->
      <!--<mobile-menu></mobile-menu>-->

      <template slot="links">
        <sidebar-item
          class="user-profile-item"
          style="padding-bottom: 1rem"
          :link="{ name: title, icon: 'person_outline', path: '/portal/reader' }"
        >
          <sidebar-item :link="{ name: 'My Settings', icon: 'settings', path: '/portal/reader/my-settings' }" />
          <sidebar-item
            v-if="isDoctor"
            :link="{ name: 'Profile', icon: 'account_circle', path: '/portal/reader/doctor/profile' }"
          />
        </sidebar-item>
        <span class="user-role">Reader</span>
        <div style="border-bottom: solid 1px rgba(180, 180, 180, 0.3); margin-left: 1rem; margin-right: 1rem"></div>
        <!--
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'home',
            path: '/portal/reader/dashboard'
          }"
        />
        -->

        <sidebar-item
          :link="{
            name: 'Screenings',
            icon: 'visibility',
            path: '/portal/reader'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Available',
              icon: 'dashboard',
              path: '/portal/reader/screenings'
            }"
          />
          <sidebar-item
            :link="{
              name: 'On-Hold',
              icon: 'dashboard',
              path: '/portal/reader/Onhold'
            }"
          />
        </sidebar-item>

        <!-- REPORTS -->
        <sidebar-item
          :link="{
            name: 'Reports',
            icon: 'assignment_ind',
            path: '/portal/reader/reports'
          }"
        />

        <!-- Patients -->
        <sidebar-item
          :link="{
            name: 'Patients',
            icon: 'person',
            path: '/portal/reader/patients'
          }"
        />

        <!-- WorkUp -->
        <sidebar-item
          :link="{
            name: 'Work Up',
            icon: 'history',
            path: '/portal/reader'
          }"
        >
          <!--PACKAGES-->
          <sidebar-item :link="{ name: 'Packages', icon: 'cloud_upload', path: '/portal/reader/packages' }" />

          <!--SiView-->
          <sidebar-item :link="{ name: 'SiVIEW', icon: 'history', path: '/portal/reader/siview' }" />
        </sidebar-item>

        <!-- Admin -->
        <sidebar-item
          :link="{
            name: 'Admin',
            icon: 'emergency',
            path: '/portal/reader'
          }"
        >
          <!-- PROVIDERS -->
          <sidebar-item
            :link="{
              name: 'Providers',
              icon: 'emergency',
              path: '/portal/reader/doctors-list'
            }"
          />

          <!-- DX-CARDS -->
          <sidebar-item
            :link="{
              name: 'Dx Cards',
              icon: 'style',
              path: '/portal/reader/dxcards'
            }"
          />

          <!-- Messages 
          <sidebar-item
            :link="{
              name: 'Messages',
             icon: 'mail_outline',
              path: '/portal/reader/messages'
            }"
          /> -->
        </sidebar-item>

        <li class="nav-item">
          <a href="http://help.globechek.com/support/home" target="_blank">
            <i class="material-icons" style="color: #ffffff !important">help</i>
            <p style="color: white">Help Desk</p>
          </a>
        </li>

        <sidebar-item
          v-show="false"
          :link="{
            name: 'Reference',
            icon: 'help_outline',
            path: '/portal/reader'
          }"
        >
          <sidebar-item
            :link="{
              name: 'ICD-10 Codes',
              icon: 'dashboard',
              path: '/portal/reader/disease-class'
            }"
          />
          <sidebar-item
            :link="{
              name: 'CPT Codes',
              icon: 'dashboard',
              path: '/portal/reader/procedure-code'
            }"
          />
          <sidebar-item
            :link="{
              name: 'HL7 FHIR',
              icon: 'dashboard',
              path: '/portal/reader/hl7-fhir'
            }"
          />
          <!--<sidebar-item :link="{ name: 'Diagnoses', icon: 'dashboard', path: '/portal/reader/diagnoses' }"></sidebar-item>-->
        </sidebar-item>

        <sidebar-item
          v-show="false"
          :link="{
            name: 'Globe',
            icon: 'nature_people',
            path: '/portal/reader'
          }"
        >
          <sidebar-item
            :link="{
              name: '2-001',
              icon: 'language',
              path: '/portal/reader/administrative'
            }"
          />
          <sidebar-item
            :link="{
              name: '3-402',
              icon: 'language',
              path: '/portal/reader/administrative'
            }"
          />
          <sidebar-item
            :link="{
              name: '3-404',
              icon: 'language',
              path: '/portal/reader/administrative'
            }"
          />
          <sidebar-item
            :link="{
              name: '3-405',
              icon: 'language',
              path: '/portal/reader/administrative'
            }"
          />
        </sidebar-item>

        <!--
        <sidebar-item :link="{ name: 'Telemedicine', icon: 'laptop', path: '/portal/reader/'}">
          <sidebar-item :link="{ name: 'Your Telehealth Room', icon: 'local_hospital', path: '/portal/reader/telemedicine'}" />
          <sidebar-item :link="{ name: 'Appointments', icon: 'schedule', path: '/portal/reader/appointments'}" />
        </sidebar-item> -->
      </template>
    </side-bar>

    <div :id="$route.path === '/portal/reader/evaluation' ? 'alt-color-panel' : ''" class="main-panel">
      <top-navbar class="top-navbar" />

      <!--
      <fixed-plugin
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage">
      </fixed-plugin>
      -->

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view
            :style="$route.path === '/portal/reader/evaluation' ? 'margin-top: 10px' : 'margin-top: 60px;'"
            align="Center"
          />
          <!--Nra: Added :key="$route.fullPath"  ...to execute HREF-->
        </zoom-center-transition>
      </div>

      <content-footer v-if="!$route.meta.hideFooter" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar"
import "perfect-scrollbar/css/perfect-scrollbar.css"

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

import TopNavbar from "./TopNavbar.vue"
import ContentFooter from "./ContentFooter.vue"
import MobileMenu from "./Extra/MobileMenu.vue"
import FixedPlugin from "@/components/GlobeChek/SettingsPlugin.vue"
import UserMenu from "./Extra/UserMenu.vue"
import { ZoomCenterTransition } from "vue2-transitions"

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    FixedPlugin,
    UserMenu,
    ZoomCenterTransition
  },
  props: {
    title: {
      type: String,
      default: sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
    }
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "purple",
      sidebarBackgroundImage: "", //"./img/sidebar-0.jpg"
      sidebarMini: true,
      sidebarImg: false,
      isDoctor: false
    }
  },

  watch: {
    sidebarMini() {
      this.minimizeSidebar()
    }
  },
  created() {
    this.$store.dispatch("listDoctors", null)
  },
  mounted() {
    this.isDoctor = sessionStorage.getItem("isDoctor") === "true"
    let docClasses = document.body.classList
    let isWindows = navigator.platform.startsWith("Win")
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar")
      initScrollbar("sidebar-wrapper")
      initScrollbar("main-panel")

      docClasses.add("perfect-scrollbar-on")
    } else {
      docClasses.add("perfect-scrollbar-off")
    }
    this.maximixeSidebar()
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    maximixeSidebar() {
      this.$sidebar.toggleMinimize()
    }
  }
}
</script>

<style lang="scss">
#alt-color-panel {
  background-color: #fff !important;
}

$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
